import BankInfo from './BankInfo';
import { reduxForm } from 'redux-form';

const RegisterBankInfo = reduxForm({
    form: 'bankAccount',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount:true
})(BankInfo);

export default RegisterBankInfo;